import React from 'react';

import IconCheck from '@svg/icons/check-green-icon.svg';

import './style.css';

type RowTableProps = {
  isHeader: boolean,
  rowContent: string[],
  rowId: string,
  toolTipText: string,
};

const RowTable = ({
  isHeader,
  rowContent,
  rowId,
  toolTipText,
}: RowTableProps): JSX.Element => {
  rowContent = rowContent?.filter(cell => cell !== '');
  if (rowContent.length <= 1) return null;
  return (<tr className={toolTipText ? "headingsRows" : null}>
    {rowContent?.map((cell, index) => {
      const JSXTag = isHeader ? 'th' : 'td';
      const key = `${JSXTag}-cell-${rowId}-${index}`;
      let content: string | JSX.Element = '';
      let cellClassName = '';

      if (index > 4)  // ignore last column
        return null
      else if(cell === 'true')  // show check icon
        content = <IconCheck />;
      else if (!(isHeader && index === 0))  // hide subtitle text
        content = cell;

      const strLength = content.length;

      if (index < 1) {
        cellClassName = "toolTipStyles";
      } else if (JSXTag === "th") {
        cellClassName = "thHeaders";
      } else if (JSXTag === "td") {
        switch (true) {
          case strLength === 1:
            cellClassName = "tdSingle";
            break;
          case strLength === 2:
            cellClassName = "tdDouble";
            break;
          case strLength === undefined:
            cellClassName = "tdSVG";
            break;
          case content === "Basic" || content === "Premium" || content === "Limited":
            cellClassName = "tdLimited";
            break;
          case content.includes(",") || content.includes("Up to"):
            cellClassName = "tdNumbers";
            break;
          default:
            cellClassName = null;
        }
      }

      return (
        <JSXTag 
          key={key} 
          data-text={index < 1 ? toolTipText : null}
          className={cellClassName}
        >
          {content}
        </JSXTag>
      )
    })}
  </tr>)
  };

export default RowTable;